import React, { useEffect } from "react";
import { logCaseVisit } from "../../services/api";

const Dtp = () => {
  useEffect(() => {
    logCaseVisit("RTA").catch((error) => {
      console.error("Не удалось залогировать посещение кейса RTA", error);
    });
  }, []);

  return (
    <iframe
      src="https://iframe.iteamsolutions.kz/dtp"
      title="dtp"
      style={{ border: "none" }}
      width="100%"
      height="100%"
    />
  );
};

export default Dtp;
